import { RootState } from 'store/reducers';

export const callbackTriggersSelector = (state: RootState) => state.callbackTriggers.callbackTriggers;
